module.exports = __webpack_public_path__ + "static/hp-bg-mobile-42db591cbf05ea878098ceda99272ba6.jpg";